// === SOUND ENGINE ===
export class SoundEngine {
    constructor() {
        // SoundEngine specific setup
        this.ctx = null; this.enabled = true; this.vol = 0.3; this.lastHitTime = 0; this.lastMobHitTime = 0;
        try {
            this.ctx = new (window.AudioContext || window.webkitAudioContext)();
            this.master = this.ctx.createGain(); this.master.gain.value = this.vol; this.master.connect(this.ctx.destination);
            this.compressor = this.ctx.createDynamicsCompressor(); this.compressor.connect(this.master);
        } catch (e) { this.enabled = false; }
    }
    resume() { if (this.ctx && this.ctx.state === 'suspended') this.ctx.resume(); }
    play(fn) { if (!this.enabled || !this.ctx) return; this.resume(); try { fn(this.ctx, this.compressor, this.ctx.currentTime); } catch (e) { } }
    hit(pitch) {
        const now = performance.now(); if (now - this.lastHitTime < 150) return; this.lastHitTime = now;
        this.play((c, out, t) => {
            const g = c.createGain(); g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.08); g.connect(out);
            const o = c.createOscillator(); o.type = 'triangle'; o.frequency.setValueAtTime(180 * (pitch || 1), t); o.frequency.exponentialRampToValueAtTime(100, t + 0.06); o.connect(g); o.start(t); o.stop(t + 0.08);
        });
    }
    blockBreak(pitch) {
        this.play((c, out, t) => {
            const p = 0.8 + Math.random() * 0.4;
            const g = c.createGain(); g.gain.setValueAtTime(0.3, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.15); g.connect(out);
            const buf = c.createBuffer(1, c.sampleRate * 0.12, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++)d[i] = (Math.random() * 2 - 1) * Math.exp(-i / (c.sampleRate * 0.05));
            const ns = c.createBufferSource(); ns.buffer = buf; const f = c.createBiquadFilter(); f.type = 'bandpass'; f.frequency.setValueAtTime(1500 * p, t); f.Q.value = 2;
            ns.connect(f); f.connect(g); ns.start(t); ns.stop(t + 0.15);
        });
    }
    blockPlace() {
        this.play((c, out, t) => {
            const p = 0.9 + Math.random() * 0.2;
            const o = c.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(180 * p, t); o.frequency.exponentialRampToValueAtTime(120 * p, t + 0.08);
            const g = c.createGain(); g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.1); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.1);
        });
    }
    jump() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(220, t); o.frequency.exponentialRampToValueAtTime(440, t + 0.08);
            const g = c.createGain(); g.gain.setValueAtTime(0.12, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.1); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.1);
        });
    }
    land() {
        this.play((c, out, t) => {
            const buf = c.createBuffer(1, c.sampleRate * 0.06, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++)d[i] = (Math.random() * 2 - 1) * 0.3; const ns = c.createBufferSource(); ns.buffer = buf;
            const f = c.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 600; const g = c.createGain(); g.gain.setValueAtTime(0.2, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.08);
            ns.connect(f); f.connect(g); g.connect(out); ns.start(t); ns.stop(t + 0.08);
        });
    }
    step() {
        this.play((c, out, t) => {
            const p = 0.8 + Math.random() * 0.4;
            const buf = c.createBuffer(1, c.sampleRate * 0.03, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++)d[i] = (Math.random() * 2 - 1) * 0.12; const ns = c.createBufferSource(); ns.buffer = buf;
            const f = c.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 400 * p; const g = c.createGain(); g.gain.setValueAtTime(0.06, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.04);
            ns.connect(f); f.connect(g); g.connect(out); ns.start(t); ns.stop(t + 0.04);
        });
    }
    mobHit() {
        const now = performance.now(); if (now - this.lastMobHitTime < 120) return; this.lastMobHitTime = now;
        this.play((c, out, t) => {
            const p = 0.7 + Math.random() * 0.6; const o = c.createOscillator(); o.type = 'sawtooth'; o.frequency.setValueAtTime(400 * p, t); o.frequency.exponentialRampToValueAtTime(100, t + 0.1);
            const g = c.createGain(); g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.12); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.12);
        });
    }
    mobDie() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(600, t); o.frequency.exponentialRampToValueAtTime(100, t + 0.3);
            const g = c.createGain(); g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.3); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.3);
        });
    }
    pickup() {
        this.play((c, out, t) => {
            [0, 0.04, 0.08].forEach((d, i) => {
                const o = c.createOscillator(); o.type = 'sine'; o.frequency.value = [600, 800, 1000][i];
                const g = c.createGain(); g.gain.setValueAtTime(0, t + d); g.gain.linearRampToValueAtTime(0.12, t + d + 0.02); g.gain.exponentialRampToValueAtTime(0.01, t + d + 0.06);
                o.connect(g); g.connect(out); o.start(t + d); o.stop(t + d + 0.06);
            });
        });
    }
    hurt() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sawtooth'; o.frequency.setValueAtTime(200, t); o.frequency.linearRampToValueAtTime(150, t + 0.15);
            const g = c.createGain(); g.gain.setValueAtTime(0.2, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.2); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.2);
        });
    }
    swing() {
        this.play((c, out, t) => {
            const buf = c.createBuffer(1, c.sampleRate * 0.06, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) { const env = 1 - i / d.length; d[i] = (Math.random() * 2 - 1) * env * 0.1; } const ns = c.createBufferSource(); ns.buffer = buf;
            const f = c.createBiquadFilter(); f.type = 'highpass'; f.frequency.value = 2000; const g = c.createGain(); g.gain.value = 0.08;
            ns.connect(f); f.connect(g); g.connect(out); ns.start(t); ns.stop(t + 0.06);
        });
    }
    bossRoar() {
        this.play((c, out, t) => {
            for (let i = 0; i < 3; i++) { const d = i * 0.05; const o = c.createOscillator(); o.type = 'sawtooth'; o.frequency.setValueAtTime(120 - i * 20, t + d); o.frequency.exponentialRampToValueAtTime(40, t + d + 0.5); const g = c.createGain(); g.gain.setValueAtTime(0.3, t + d); g.gain.exponentialRampToValueAtTime(0.01, t + d + 0.5); o.connect(g); g.connect(out); o.start(t + d); o.stop(t + d + 0.5); }
            const buf = c.createBuffer(1, c.sampleRate * 0.4, c.sampleRate); const data = buf.getChannelData(0); for (let i = 0; i < data.length; i++)data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (c.sampleRate * 0.15)) * 0.3; const ns = c.createBufferSource(); ns.buffer = buf; const g2 = c.createGain(); g2.gain.value = 0.25; ns.connect(g2); g2.connect(out); ns.start(t); ns.stop(t + 0.4);
        });
    }
    bossDash() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sawtooth'; o.frequency.setValueAtTime(300, t); o.frequency.exponentialRampToValueAtTime(80, t + 0.15); const g = c.createGain(); g.gain.setValueAtTime(0.2, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.15); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.15);
        });
    }
    bossHit() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'triangle'; o.frequency.setValueAtTime(500, t); o.frequency.exponentialRampToValueAtTime(150, t + 0.1); const g = c.createGain(); g.gain.setValueAtTime(0.3, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.12); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.12);
        });
    }
    bossDeath() {
        this.play((c, out, t) => {
            for (let i = 0; i < 5; i++) { const d = i * 0.12; const o = c.createOscillator(); o.type = i % 2 === 0 ? 'sawtooth' : 'square'; o.frequency.setValueAtTime(200 - i * 25, t + d); o.frequency.exponentialRampToValueAtTime(30, t + d + 0.6); const g = c.createGain(); g.gain.setValueAtTime(0.25, t + d); g.gain.exponentialRampToValueAtTime(0.01, t + d + 0.6); o.connect(g); g.connect(out); o.start(t + d); o.stop(t + d + 0.6); }
            const buf = c.createBuffer(1, c.sampleRate * 0.8, c.sampleRate); const data = buf.getChannelData(0); for (let i = 0; i < data.length; i++)data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (c.sampleRate * 0.3)) * 0.4; const ns = c.createBufferSource(); ns.buffer = buf; const g2 = c.createGain(); g2.gain.value = 0.3; ns.connect(g2); g2.connect(out); ns.start(t); ns.stop(t + 0.8);
        });
    }
    bossPhaseChange() {
        this.play((c, out, t) => {
            for (let i = 0; i < 4; i++) { const d = i * 0.08; const o = c.createOscillator(); o.type = 'square'; o.frequency.setValueAtTime(80 + i * 40, t + d); o.frequency.exponentialRampToValueAtTime(40, t + d + 0.4); const g = c.createGain(); g.gain.setValueAtTime(0.3, t + d); g.gain.exponentialRampToValueAtTime(0.01, t + d + 0.4); o.connect(g); g.connect(out); o.start(t + d); o.stop(t + d + 0.4); }
        });
    }

    // === LIQUID SOUNDS ===
    splash(intensity = 0.5) {
        this.play((c, out, t) => {
            intensity = Math.max(0.2, Math.min(1.0, intensity));
            const vol = 0.25 + intensity * 0.25;

            // 1. Splash Impact (Low thud)
            // Filtered noise swooping down
            const bufSize = Math.floor(c.sampleRate * 0.4);
            const buf = c.createBuffer(1, bufSize, c.sampleRate);
            const data = buf.getChannelData(0);
            for (let i = 0; i < bufSize; i++) {
                // Decay envelope
                data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufSize, 3);
            }
            const impact = c.createBufferSource();
            impact.buffer = buf;
            const impactFilter = c.createBiquadFilter();
            impactFilter.type = 'lowpass';
            impactFilter.frequency.setValueAtTime(600 + intensity * 600, t);
            impactFilter.frequency.exponentialRampToValueAtTime(100, t + 0.3);

            const impactGain = c.createGain();
            impactGain.gain.setValueAtTime(vol * 0.8, t);
            impactGain.gain.exponentialRampToValueAtTime(0.01, t + 0.3);

            impact.connect(impactFilter); impactFilter.connect(impactGain); impactGain.connect(out);
            impact.start(t);

            // 2. Liquid Body (The "Bloop")
            const bloop = c.createOscillator();
            bloop.type = 'sine';
            bloop.frequency.setValueAtTime(400 + intensity * 200, t);
            bloop.frequency.exponentialRampToValueAtTime(50, t + 0.15);

            const bloopGain = c.createGain();
            bloopGain.gain.setValueAtTime(vol * 0.4, t);
            bloopGain.gain.exponentialRampToValueAtTime(0.01, t + 0.15);

            bloop.connect(bloopGain); bloopGain.connect(out);
            bloop.start(t); bloop.stop(t + 0.15);

            // 3. Spray/Droplets (High frequency random pings)
            const numDrops = Math.floor(4 + intensity * 8);
            for (let i = 0; i < numDrops; i++) {
                const dropDelay = Math.random() * 0.25;
                const drop = c.createOscillator();
                drop.type = 'sine';
                const startFreq = 600 + Math.random() * 1200;
                drop.frequency.setValueAtTime(startFreq, t + dropDelay);
                drop.frequency.exponentialRampToValueAtTime(startFreq * 0.5, t + dropDelay + 0.05); // quick pitch drop

                const dropGain = c.createGain();
                dropGain.gain.setValueAtTime(0, t + dropDelay);
                dropGain.gain.linearRampToValueAtTime(vol * (0.1 + Math.random() * 0.1), t + dropDelay + 0.01);
                dropGain.gain.exponentialRampToValueAtTime(0.001, t + dropDelay + 0.05);

                drop.connect(dropGain); dropGain.connect(out);
                drop.start(t + dropDelay); drop.stop(t + dropDelay + 0.06);
            }
        });
    }
    swimStroke() {
        this.play((c, out, t) => {
            // Smoother "swish" sound
            const dur = 0.25;
            const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
            const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) {
                // Sine-windowed noise
                const env = Math.sin((i / d.length) * Math.PI);
                d[i] = (Math.random() * 2 - 1) * env;
            }
            const noise = c.createBufferSource(); noise.buffer = buf;

            // Bandpass swipe
            const f = c.createBiquadFilter();
            f.type = 'lowpass';
            f.frequency.setValueAtTime(400, t);
            f.frequency.linearRampToValueAtTime(800, t + 0.1);
            f.frequency.linearRampToValueAtTime(200, t + 0.25);

            const g = c.createGain();
            g.gain.setValueAtTime(0.02, t);
            g.gain.linearRampToValueAtTime(0.08, t + 0.1);
            g.gain.linearRampToValueAtTime(0.001, t + 0.25);

            noise.connect(f); f.connect(g); g.connect(out);
            noise.start(t); noise.stop(t + dur);
        });
    }
    bubble() {
        this.play((c, out, t) => {
            // Tiny bubble pop sound
            const p = 0.8 + Math.random() * 0.6;
            const o = c.createOscillator(); o.type = 'sine';
            o.frequency.setValueAtTime(600 * p, t);
            o.frequency.exponentialRampToValueAtTime(1200 * p, t + 0.03);
            o.frequency.exponentialRampToValueAtTime(400 * p, t + 0.06);
            const g = c.createGain();
            g.gain.setValueAtTime(0.03, t);
            g.gain.exponentialRampToValueAtTime(0.01, t + 0.02);
            g.gain.exponentialRampToValueAtTime(0.001, t + 0.06);
            o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.06);
        });
    }
    underwaterAmbience() {
        if (!this.enabled || !this.ctx) return;
        this.resume();
        try {
            const c = this.ctx, out = this.compressor, t = c.currentTime;
            // Low rumble
            const dur = 1.5;
            const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
            const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) {
                const env = Math.sin((i / d.length) * Math.PI) * 0.5;
                d[i] = (Math.random() * 2 - 1) * env;
            }
            const ns = c.createBufferSource(); ns.buffer = buf;
            const lp = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 200;
            const g = c.createGain(); g.gain.value = 0.04;
            ns.connect(lp); lp.connect(g); g.connect(out);
            ns.start(t); ns.stop(t + dur);
            // Occasional bubble tones
            for (let i = 0; i < 2; i++) {
                const delay = 0.3 + Math.random() * 0.8;
                const o = c.createOscillator(); o.type = 'sine';
                o.frequency.setValueAtTime(400 + Math.random() * 300, t + delay);
                o.frequency.exponentialRampToValueAtTime(800, t + delay + 0.04);
                const g2 = c.createGain();
                g2.gain.setValueAtTime(0.015, t + delay);
                g2.gain.exponentialRampToValueAtTime(0.001, t + delay + 0.06);
                o.connect(g2); g2.connect(out);
                o.start(t + delay); o.stop(t + delay + 0.08);
            }
        } catch (e) { }
    }

    // === AMBIENT BIOME SOUNDS ===
    ambientWind(intensity = 0.5) {
        if (!this.enabled || !this.ctx) return;
        this.resume();
        try {
            const c = this.ctx, out = this.compressor, t = c.currentTime;
            const bufferSize = c.sampleRate * 2;
            const buffer = c.createBuffer(1, bufferSize, c.sampleRate);
            const data = buffer.getChannelData(0);
            for (let i = 0; i < bufferSize; i++) data[i] = (Math.random() * 2 - 1) * intensity;
            const noise = c.createBufferSource();
            noise.buffer = buffer;
            noise.loop = true;
            const filter = c.createBiquadFilter();
            filter.type = 'lowpass';
            filter.frequency.value = 400 + intensity * 600;
            const g = c.createGain();
            g.gain.value = 0.05 * intensity;
            noise.connect(filter);
            filter.connect(g);
            g.connect(out);
            noise.start(t);
            setTimeout(() => { try { noise.stop(); } catch (e) { } }, 2000);
        } catch (e) { }
    }

    ambientWater() {
        if (!this.enabled || !this.ctx) return;
        this.resume();
        try {
            const c = this.ctx, out = this.compressor, t = c.currentTime;
            for (let i = 0; i < 3; i++) {
                const o = c.createOscillator();
                o.type = 'sine';
                o.frequency.setValueAtTime(100 + Math.random() * 50, t);
                o.frequency.setValueAtTime(120 + Math.random() * 60, t + 1);
                const g = c.createGain();
                g.gain.setValueAtTime(0.02, t);
                g.gain.setValueAtTime(0.015, t + 1);
                o.connect(g);
                g.connect(out);
                o.start(t + i * 0.3);
                o.stop(t + 1.5);
            }
        } catch (e) { }
    }

    ambientCave() {
        if (!this.enabled || !this.ctx) return;
        this.resume();
        try {
            const c = this.ctx, out = this.compressor, t = c.currentTime;
            const o = c.createOscillator();
            o.type = 'triangle';
            o.frequency.setValueAtTime(60, t);
            o.frequency.exponentialRampToValueAtTime(40, t + 2);
            const g = c.createGain();
            g.gain.setValueAtTime(0.03, t);
            g.gain.exponentialRampToValueAtTime(0.001, t + 2);
            o.connect(g);
            g.connect(out);
            o.start(t);
            o.stop(t + 2);
        } catch (e) { }
    }
    // === SPECIAL WEAPON SOUNDS ===
    fireShot() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sawtooth'; o.frequency.setValueAtTime(400, t); o.frequency.exponentialRampToValueAtTime(100, t + 0.15);
            const g = c.createGain(); g.gain.setValueAtTime(0.15, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.2); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.2);
            // Crackle
            const buf = c.createBuffer(1, c.sampleRate * 0.1, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.exp(-i / (c.sampleRate * 0.03)) * 0.15;
            const ns = c.createBufferSource(); ns.buffer = buf; const g2 = c.createGain(); g2.gain.value = 0.1; ns.connect(g2); g2.connect(out); ns.start(t); ns.stop(t + 0.1);
        });
    }
    iceShot() {
        this.play((c, out, t) => {
            const o = c.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(800, t); o.frequency.exponentialRampToValueAtTime(300, t + 0.12);
            const g = c.createGain(); g.gain.setValueAtTime(0.12, t); g.gain.exponentialRampToValueAtTime(0.01, t + 0.15); o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.15);
        });
    }
    lightningShot() {
        this.play((c, out, t) => {
            const buf = c.createBuffer(1, c.sampleRate * 0.08, c.sampleRate); const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length) * 0.25;
            const ns = c.createBufferSource(); ns.buffer = buf; const g = c.createGain(); g.gain.value = 0.2; ns.connect(g); g.connect(out); ns.start(t); ns.stop(t + 0.08);
            const o = c.createOscillator(); o.type = 'square'; o.frequency.setValueAtTime(1200, t); o.frequency.exponentialRampToValueAtTime(200, t + 0.06);
            const g2 = c.createGain(); g2.gain.setValueAtTime(0.1, t); g2.gain.exponentialRampToValueAtTime(0.01, t + 0.08); o.connect(g2); g2.connect(out); o.start(t); o.stop(t + 0.08);
        });
    }
    accessoryPickup() {
        this.play((c, out, t) => {
            for (let i = 0; i < 4; i++) {
                const d = i * 0.06;
                const o = c.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(400 + i * 100, t + d);
                const g = c.createGain(); g.gain.setValueAtTime(0.15, t + d); g.gain.exponentialRampToValueAtTime(0.01, t + d + 0.15);
                o.connect(g); g.connect(out); o.start(t + d); o.stop(t + d + 0.15);
            }
        });
    }
}
export const sfx = new SoundEngine();